import Axios from 'axios';

// These imports are absolute, and this works because of the jsconfig.json file in the root of the project
import config from '../config';

// get base api url from config
const apiBaseUrl = config.feedbackApi.baseUrl;

// preconfigured axios instance with base url and version built in
export const axios = Axios.create({
	baseURL: apiBaseUrl,
});

// simplified interface, encourages consistency
export const api = {
	getUserData: (options) => axios.get('/proxy/feedback/analytic/info', options),
};

export default api;
